/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Delete_ConfirmInputs */

const cs_gallery_delete_confirm = /** @type {(inputs: Gallery_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tuto fotku?`)
};

const en_gallery_delete_confirm = /** @type {(inputs: Gallery_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this photo?`)
};

/**
* | output |
* | --- |
* | "Delete this photo?" |
*
* @param {Gallery_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_delete_confirm = /** @type {((inputs?: Gallery_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_delete_confirm(inputs)
	return cs_gallery_delete_confirm(inputs)
});